class CustomTextSlider extends HTMLElement {
    constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.target = `${this.sectionId}--splideProperties`
        this.mySplide = this.querySelector('.splide');
        this.optionText = this.querySelector(`#${this.sectionId}--splideProperties`).textContent
        this.options = JSON.parse(this.optionText);
        this.initSlider();
    }

    initSlider() {
        new Splide(this.mySplide, this.options).mount(window.splide.Extensions);
    }
}

customElements.define('custom-text-slider', CustomTextSlider)